var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKusamaDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8104_43828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.43806 14.6973V14.8864C1.43806 14.8864 8.81192 12.1574 10.2454 12.8622L9.38072 13.1007C9.45641 13.1007 10.8578 13.1867 10.8578 13.1867C10.8906 13.4578 10.9873 13.7187 11.1408 13.9506C11.2943 14.1825 11.5008 14.3795 11.7454 14.5276C12.5894 15.0497 12.6055 15.3334 12.6055 15.3334C12.6055 15.3334 12.1674 15.501 12.1674 15.7137C12.5748 15.6045 12.996 15.5474 13.4197 15.544C13.8019 15.5567 14.1809 15.6138 14.5482 15.7137C14.5482 15.7137 14.5046 15.4988 13.9151 15.3334C13.3257 15.1679 12.7569 14.5834 12.4702 14.259C12.2982 14.0516 12.1867 13.8059 12.1465 13.546C12.1063 13.2861 12.1388 13.0209 12.2408 12.7763C12.4449 12.2863 13.1583 12.0134 14.6055 11.3086C16.3234 10.477 16.7156 9.85383 16.9564 9.37464C17.1972 8.89545 17.5596 7.93492 17.7592 7.48366C17.9251 7.06188 18.2105 6.69043 18.5849 6.40924C18.8394 6.22659 20 5.81616 20 5.81616C20 5.81616 19.1147 5.10919 18.8257 4.89645C18.4645 4.57595 18.0077 4.36609 17.516 4.29478C16.9014 4.21957 16.2775 4.60206 15.8555 4.85777C15.4335 5.11349 14.617 5.86128 14.2867 6.07617C13.9564 6.29105 13.1101 6.50594 11.7638 7.27737C10.4174 8.0488 5.07339 11.2441 5.07339 11.2441L6.44953 11.257L0.272934 14.259H0.889912L0 14.9036C0.492881 15.0093 1.01023 14.9356 1.44725 14.6973H1.43806Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8104_43828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKusamaDark);
export default __webpack_public_path__ + "static/media/kusama-dark.23709f8bbfdf385ce41c17ca6415be94.svg";
export { ForwardRef as ReactComponent };